import { Component, OnInit } from '@angular/core';
import { FundinstitutionService } from '../service/fundinstitution.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fund-institution-list',
  templateUrl: './fund-institution-list.component.html',
  styleUrls: ['./fund-institution-list.component.css']
})
export class FundInstitutionListComponent implements OnInit {
  resultTable: any[] = null;
  cols: any[];
  msgs: any[] = [];

  constructor(private dataService: FundinstitutionService, private router: Router) { }
  ngOnInit() {
    this.getList();

    this.cols = [
      { field: 'IncomeTaxAuthorizationNumber', header: 'מספר אישור' },
      { field: 'Name', header: 'שם מוצר' },
      { field: 'Type', header: 'סוג מוצר' },
      { field: 'InstitutionName', header: 'שם הגוף המוסדי' },
      { field: 'IdentityNumber', header: 'ח.פ הגוף המוסדי' },
      { field: 'BankName', header: 'שם בנק' },
      { field: 'BankNumber', header: 'מספר בנק' },
      { field: 'BankBranch', header: 'שם סניף בנק' },
      { field: 'BranchNumber', header: 'מספר סניף בנק' },
      { field: 'AccountNumber', header: 'מספר חשבון' },
      { field: 'EmailFinanceSupport', header: 'כתובת דוא"ל לבירורים בנושאי כספים' },
      { field: 'Active', header: 'פעיל' },
      { field: 'Notes', header: 'הערה' },
    ];
  }

  getList(): any {
    this.dataService.getFundinstitution().subscribe((result: any) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת קופות ');
      });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  redirectToUpdate(fundInstitutionId: number): void {
    if (fundInstitutionId > 0 && (fundInstitutionId != null && fundInstitutionId != undefined)) {
      this.router.navigate(['/fundinstitution-update', fundInstitutionId]);
    } else {
      this.showMessage('error', '', 'תקלה בעדכון');
    }
  }

  delete(fundInstitutionId: number): void {
    //debugger;
    if (fundInstitutionId > 0 && (fundInstitutionId != null && fundInstitutionId != undefined)) {
      let ok = confirm('האם ברצונך למחוק את הרשומה?');
      if (ok) {
        this.dataService.delete(fundInstitutionId).subscribe((result: any) => {
          if (result == "Success") {
            this.showMessage('success', '', 'מחיקה בוצעה בהצלחה');
            this.getList();
          }
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה במחיקה');
        });
      }
    }
    else {
      this.showMessage('error', '', 'תקלה במחיקה');
    }
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/fund-institution-list/fund-institution-list.component.ts